export default __webpack_public_path__ + "static/media/bug.8df2352c.svg";